__turbopack_context__.v({
  "fullScreenLoader": "full-screen-loader-module-scss-module__gyssUq__fullScreenLoader",
  "fullScreenLoaderWrapper": "full-screen-loader-module-scss-module__gyssUq__fullScreenLoaderWrapper",
  "screenLoader": "full-screen-loader-module-scss-module__gyssUq__screenLoader",
});
